const SEASON_TIMEZONE = 'America/Sao_Paulo';

function localeFor(language: string): string {
  return language === 'pt' || language.startsWith('pt-') ? 'pt-BR' : 'en-US';
}

export function formatSeasonDate(
  iso: string | null | undefined,
  language: string,
): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;

  return new Intl.DateTimeFormat(localeFor(language), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: SEASON_TIMEZONE,
  }).format(date);
}

export function formatSeasonRange({
  startsAt,
  endsAt,
  language,
}: {
  startsAt?: string | null;
  endsAt?: string | null;
  language: string;
}): { start: string | null; end: string | null } {
  return {
    start: formatSeasonDate(startsAt, language),
    end: formatSeasonDate(endsAt, language),
  };
}

function saoPauloYmd(iso: string): { year: number; month: number; day: number } | null {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: SEASON_TIMEZONE,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).formatToParts(date);
  const read = (type: string) => {
    const value = parts.find((part) => part.type === type)?.value;
    return value ? Number(value) : NaN;
  };
  const year = read('year');
  const month = read('month');
  const day = read('day');
  if (![year, month, day].every(Number.isFinite)) return null;
  return { year, month, day };
}

function saoPauloMidnightIso(year: number, month: number, day: number): string {
  return new Date(Date.UTC(year, month - 1, day, 3, 0, 0, 0)).toISOString();
}

export function inferSeasonStartFromEnd(
  endsAt?: string | null,
): string | null {
  if (!endsAt) return null;
  const ymd = saoPauloYmd(endsAt);
  if (!ymd) return null;
  if (ymd.month === 12 && ymd.day === 31) {
    return saoPauloMidnightIso(ymd.year, 7, 1);
  }
  if (ymd.month === 6 && ymd.day === 30) {
    return saoPauloMidnightIso(ymd.year, 1, 1);
  }
  return null;
}
